import Autoplay from 'embla-carousel-autoplay';
import useEmblaCarousel from 'embla-carousel-react';
import { useRef } from 'react';
import { useFetch } from '@/app/hooks';
import { getCreations } from '../apis';
import { CAROUSEL_DELAY, PAGE_SIZE } from '../constants';

export const CreationCarousel = () => {
  const autoplayRef = useRef<ReturnType<typeof Autoplay>>(
    Autoplay({ delay: CAROUSEL_DELAY, stopOnInteraction: false }),
  );
  const [emblaRef] = useEmblaCarousel({ loop: true }, [autoplayRef.current]);

  const { data: videoResources } = useFetch(() =>
    getCreations({ query: { 'pager.page': 0, 'pager.pagesz': PAGE_SIZE, item_type: 'carousel_item' } }),
  );
  const data = videoResources?.data;

  return (
    <div ref={emblaRef} className="overflow-hidden">
      <div className="relative flex h-screen md:h-[492px]">
        {data?.creatives?.map(({ creation }) => (
          <div
            key={creation?.uri}
            className="relative flex h-full w-full min-w-0 shrink-0 grow basis-full items-center justify-center pt-0 pl-0"
          >
            <video
              controls={false}
              poster={creation?.cover_uri}
              muted
              autoPlay
              loop
              playsInline
              webkit-playsinline="true"
              x5-playsinline="true"
              className="h-full w-full object-cover object-center"
            >
              <source src={creation?.uri} type="video/mp4" />
            </video>
          </div>
        ))}
      </div>
    </div>
  );
};
